import {
  AppliedMaterials,
  COUNTERTOP_MATERIAL_INDEX,
  VISUALIZER_IFRAME_ID,
  VisualizerMessageData,
} from './ColorVizContent.types';

/**
 * Extracts the countertop color name from applied materials.
 * The countertop is always at index 2 in the applied materials object.
 */
export const getCountertopColorName = (
  appliedMaterials: AppliedMaterials
): string | undefined => {
  const materialKeys = Object.keys(appliedMaterials);
  const countertopKey = materialKeys[COUNTERTOP_MATERIAL_INDEX];

  if (!countertopKey) {
    return undefined;
  }

  return appliedMaterials[countertopKey]?.materialName;
};

/**
 * Type guard to check if message data contains valid visualizer response.
 */
export const isValidVisualizerMessage = (
  data: VisualizerMessageData
): data is Required<
  Pick<VisualizerMessageData, 'screenshotImg' | 'appliedMaterials'>
> &
  VisualizerMessageData => {
  if (!data?.screenshotImg || !data?.appliedMaterials) {
    return false;
  }

  return Object.keys(data.appliedMaterials).length > 0;
};

/**
 * Checks if the countertop color differs from the currently selected color.
 */
export const hasColorChanged = (
  countertopColorName: string | undefined,
  selectedColorName: string | undefined
): boolean => {
  if (!countertopColorName || !selectedColorName) {
    return false;
  }

  return countertopColorName !== selectedColorName;
};

/**
 * Gets the visualizer iframe element and validates it's ready for communication.
 * Returns null if iframe doesn't exist or contentWindow is not accessible.
 */
export const getVisualizerIframe = (): HTMLIFrameElement | null => {
  const iframe = document.querySelector(
    `#${VISUALIZER_IFRAME_ID}`
  ) as HTMLIFrameElement | null;

  if (!iframe?.contentWindow) {
    return null;
  }

  return iframe;
};
